<template lang="pug">
div
  .app-bar-fixed-area#app-bar(v-if="fixed")
  .app-bar(:class="{'milk-shadow' : shadow, 'app-bar-fixed': fixed, 'app-bar-border' : borderBottom}")
    .app-bar-left-area
      slot(name="left")
    .app-bar-title {{title}}
    .app-bar-right-area
      slot(name="right")
</template>

<script>
export default {
  name: 'rr-app-bar',
  data () {
    return {
      borderBottom: false
    }
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    shadow: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    observerEl () {
      if (!this.fixed) return
      let targetEl = document.querySelector('#app-bar')
      var options = {
          rootMargin: '0px', 
          threshold: 1
      }
      var callback = (entries, observer) => {
        entries.forEach(entry => {
          this.borderBottom = !entry.isIntersecting
        });
      };
      var observer = new IntersectionObserver(callback, options);
      observer.observe(targetEl)
    }
  },
  mounted () {
    this.observerEl()
  }
}
</script>

<style lang="sass" scoped>


.app-bar-fixed-area
  height: 60px
  width: 100%
  max-width: 375px
.app-bar-fixed
  position: fixed
  top: 0
.app-bar
  height: 60px
  z-index: 999
  width: 100%
  max-width: 375px
  padding: 0 21px
  padding-top: constant(safe-area-inset-top)
  padding-top: env(safe-area-inset-top)
  background: white
  @include flex($justifyContent: space-between)
  *
    color: $secondary
  .app-bar-title
    font-size: 15px
    flex: 1
    text-align: center
  .iconfont
    font-size: 20px
.app-bar-border
  border-bottom: 1px solid #E6E7E8
</style>